import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, COMPANY_EMPLOYEE_ID, PRODUCT_SLUG } from "../../config";
import axios from "../../api/axios";
import chatAxios from "../../api/chats";

const cookies = new Cookies();

const useGet = ({
  url,
  initialData,
  onSuccess,
  onError,
  onSettled,
  enabled = true,
  isChat = false,
  returnEntireResponse = false,
  isIncludeCompanyId = true,
}) => {
  const [paramsObject, setGetListParams] = useState(initialData);
  const company_id = cookies.get(COMPANY_ID);
  const company_employee_id = cookies.get(COMPANY_EMPLOYEE_ID);

  const getUsers = async (paramsObject) => {
    let token = cookies.get(TOKEN_NAME);

    const params = {
      ...paramsObject,
      ...(isIncludeCompanyId && { company_id }),
      product_slug: PRODUCT_SLUG,
      ...(isChat && { company_employee_id }),
    };

    const axiosInstance = isChat ? chatAxios : axios;

    const response = await axiosInstance.get(`/${url}`, {
      params,
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    if (returnEntireResponse) {
      return response;
    } else {
      return response.data;
    }
  };

  const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
    refetchOnWindowFocus: false,
    enabled: enabled,
    retry: 0,
    onSuccess(data) {
      onSuccess?.(data);
    },
    onError(err) {
      onError?.(err);
    },
    onSettled() {
      onSettled?.();
    },
  });

  return { list, paramsObject, setGetListParams };
};

export default useGet;
